module.exports = __webpack_public_path__ + "img/internet.28551f22.svg";